(function() {
  // Variables globales
  const productVariants = CurrentProduct;
  const templateName = CurrentTemplate;
  const selectedOptions = { color: null, size: null };
  const getUrl = window.location;
  const variantColorEls = document.querySelectorAll('.variant_color');
  const variantSizeEls = document.querySelectorAll('.variant_size');
  const colorSelectedEl = document.querySelector('.color-selected');
  const sizeSelectedEl = document.querySelector('.size-selected');
  const productSelectEl = document.querySelector('#ProductSelect');
  const addToCartBtn = document.querySelector('#AddToCartBtnBsl');
  const variantSeletedImg = document.querySelector('#gallery-section__image-selected');

  // Funtions
  async function addToCartClickHandler(event) {
    const bodyElement = document.querySelector('body');
    const drawerCart = document.querySelector('#drawer__cart')
    event.preventDefault();
    const form = event.target.parentNode;
    const formData = new FormData(form);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      const json = await response.json();
      Neptune.cart.getCart();
      bodyElement.setAttribute('data-active-modal', 'drawer--cart');
      drawerCart.classList.add('active');
    } catch (error) {
      console.log(error);
    }
  }

  function handleClick(event) {
    const optionName = event.target.parentNode.getAttribute('data-name');
    const optionValue = event.target.getAttribute('value');
    const onlyLeftInStock = document.querySelector('#only-left-in-stock');

    selectedOptions[optionName] = optionValue;
  
    const selectedVariant = getProductVariant(productVariants, selectedOptions);

    addRemoveClass(`.variant_${optionName}`, event.target, 'selected');
    updateSizeAvailability();
    if (selectedVariant) {
      colorSelectedEl.textContent = selectedVariant.options[0];
      sizeSelectedEl.textContent = cutTheTextContent(selectedVariant.options[1]);
      productSelectEl.value = selectedVariant.id;
      
      if (templateName === 'rebuild-1') renderVariantImages(selectedVariant, colorSelectedEl, event.target.dataset.swatch);
      if (optionName == 'color' || optionName == 'Color'){
      if (templateName === 'rebuild-3') filterGridImages(colorSelectedEl, event.target.dataset.swatch);
  
      }
      
      if (selectedVariant.inventory_quantity > 0 && selectedVariant.inventory_quantity <= 10) {
        onlyLeftInStock.classList.add('db','show-only-left');
        onlyLeftInStock.textContent = `${selectedVariant.inventory_quantity} left in stock for size: ${sizeSelectedEl.textContent}`
      } else {
        onlyLeftInStock.classList.remove('db','show-only-left')
      }
      const variantUrl = getUrl.search.split('nosto=').pop();
      if (!variantUrl) {
        history.pushState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
      }
      
      const soldButton = document.querySelector('.sold-out-btn');
      const backInStock = document.querySelector('.pdp-klaviyo-trigger')
      if (selectedVariant.available) {
        UpdatePriceVariant('.info-product-detail__pdp-price .money', selectedVariant.price)
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('dn-i')
        addToCartBtn.classList.remove('disabled-add-to-cart');
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        soldButton.classList.add('dn-i')
        backInStock.classList.add('dn-i');
      } else {
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled-add-to-cart');
        soldButton.classList.remove('dn-i');
        backInStock.classList.remove('dn-i');
        addToCartBtn.classList.add('dn-i');
      }
    }
  }
  

  function getProductVariant(product, selectedOptions) {
    const variantOptionCurrent = productSelectEl.selectedOptions[0].dataset.variantOptions.split('-');
    const colorSelected = selectedOptions.color || variantOptionCurrent.shift();
    const sizeSelected = selectedOptions.size || variantOptionCurrent.pop();
    const matchText = `${colorSelected} / ${sizeSelected}`;

    const selectedVariant = product.variants.find(variant => variant.title === matchText);
    UpdatePriceVariant('.info-product-detail__pdp-price .money', selectedVariant.price)
      return selectedVariant;
  }

  function setDefaultVariant() {
    const variantUrl = getUrl.search.split('?variant=').pop();
    const selectedOptions = document.querySelectorAll('.swatch-btn[selected]');
    const availableVariants = productSelectEl.querySelectorAll('option');
  
    if (variantUrl && [...availableVariants].some(v => v.value === variantUrl)) {
      productSelectEl.value = variantUrl;
      document.querySelector('.variant_size.selected').click();
      history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${variantUrl}`);
    }
    if (selectedOptions) selectedOptions.forEach(option => option.click());
  
  }
  
  //Availables variants size
  function updateSizeAvailability() {
    const color = selectedOptions.color;
    const unavailableSizes = new Array();
    const availableSizes = new Array();

    variantSizeEls.forEach(sizeEl => {
      const sizeValue = sizeEl.getAttribute('value');
      const variant = getProductVariant(productVariants, { color: color, size: sizeValue });
      
        sizeEl.dataset.colorSelected = color;
        colorSelectedEl.dataset.colorSelected = color;
        availableSizes.push(sizeValue)
        if (variant && variant.available) {
        sizeEl.classList.remove('sold-out');
      } else {
        sizeEl.classList.add('sold-out');
        unavailableSizes.push(sizeValue);
      }
      
      sizeEl.textContent = cutTheTextContent(sizeEl.dataset.cuttext);
    });
    if (templateName === 'rebuild-3'){
      findUnavailableColors(color, unavailableSizes, availableSizes);
    document.addEventListener('resize', () =>{findUnavailableColors(color, unavailableSizes, availableSizes)})
    }
  }

//Available color rebuild 3
function findUnavailableColors(color, unavailableSizes, availableSizes) {
  const colorSeld =  colorSelectedEl.dataset.colorSelected;
  const sizesContainer = document.querySelector('.product-form__item-Size');
  const unavailablePanel = document.querySelector('.unavailable-color-banner');
  if (window.innerWidth < 768) {
    //disable the add to cart btn.
    if (colorSeld === color) {

      if(parseInt(unavailableSizes.length) === parseInt(availableSizes.length)){
        addToCartBtn.classList.add('disabled-add-to-cart-mobile');
        addToCartBtn.classList.add('dn-i-mobile');
        if (unavailablePanel.classList.contains('dn-i-mobile')) unavailablePanel.classList.remove('dn-i-mobile');
        if (!sizesContainer.classList.contains('dn-i-mobile')) sizesContainer.classList.add('dn-i-mobile');

      }else{
        addToCartBtn.classList.remove('disabled-add-to-cart-mobile');
        addToCartBtn.classList.remove('dn-i-mobile');
        if (!unavailablePanel.classList.contains('dn-i-mobile')) unavailablePanel.classList.add('dn-i-mobile');
        if (sizesContainer.classList.contains('dn-i-mobile')) sizesContainer.classList.remove('dn-i-mobile');
      }
    }
    //Search all colors and view if the color at the size are sold out
    const availableColor = {};

    productVariants.variants.forEach(variant => {
      const color = variant.option1; 
      const size = variant.option2; 
    
      if (!availableColor[color]) {
        availableColor[color] = new Set(); // laCrea un conjunto para las tals disponibles del color
      }
    
      // Agrega la talla al conjunto de tallas disponibles para el color actual
      if (variant.available) availableColor[color].add(size); 
    });
    
    
    const availableColors = {};

    productVariants.variants.forEach(variant => {
      const color = variant.option1;
      const size = variant.option2;

      if (!availableColors[color]) {
        availableColors[color] = new Set();
      }

      if (variant.available) {
        availableColors[color].add(size);
      }
    });

    variantColorEls.forEach(colorEl => {
      const colorName = colorEl.dataset.colorName; 

      if (!availableColors[colorName] || availableColors[colorName].size === 0) {
        colorEl.classList.add('unavailable-color-mobile'); 
      }
    });
  }else{
    addToCartBtn.classList.remove('disabled-add-to-cart-mobile');
    addToCartBtn.classList.remove('dn-i-mobile');
    sizesContainer.classList.remove('dn-i-mobile');
    unavailablePanel.classList.add('dn-i-mobile');
  }
}

  /*Render Image Functions*/

  //main function PDP rebuild 1
  function renderVariantImages(variant, colorSelected, isColor) {
    const galleryImages = document.querySelector("#gallery-section__images");
    const colorVstd = colorSelected.dataset.colorSelected.replace(/ /g, '-');
    [...galleryImages.children].forEach((image, index) =>{
      draggableSlide('.gallery-section__images');
        if(image.dataset.colorSelected.includes(colorVstd.toLowerCase())){
          image.classList.remove('dn-i');
          image.classList.add('db-images')
        }else{
          image.classList.add('dn-i');
          image.classList.remove('db-images')
        }
          
    })

    if (isColor == 'Color') return selectFirstImageAvailable([...galleryImages.children]);
  }

  //Main function PDP Rebuild 3
  function filterGridImages(colorSelected, isColor) {
    const galleryImages = document.querySelector("#gallery-section__grid-images-selected");
    const colorVstd = colorSelected.dataset.colorSelected.replace(/ /g, '-');
    const filteredImages = [...galleryImages.children].filter((image) => {
      return image.dataset.colorSelected.includes(colorVstd.toLowerCase())
    });
    [...galleryImages.children].forEach(image => {
      image.classList.add('dn-i')
      image.classList.remove('images-selected')
    })
 
    filteredImages.forEach((image, index) =>{
      image.classList.remove('dn-i');
      image.classList.remove('images-selected')
      image.dataset.index = index;
      image.children[0].dataset.index = index;
      if (index === 0 || index === 3) {
        image.classList.add('grid-item-full', 'images-selected');
      } else {
        image.classList.add('grid-item-half', 'images-selected');
      }
    })
    if (isColor == 'Color') return selectFirstImageAvailable([...galleryImages.children]);
  }

  function crossIconModal (){
    const crossIcons = document.querySelectorAll("#gallery-section__grid-images-selected span");
    const mainZoomContainer = document.querySelector('.slide-zoom-image');
    [...crossIcons].forEach((crossIcon) => {
      crossIcon.addEventListener('click', () => {
        let crossIconIndex = parseInt(crossIcon.dataset.index);
        mainZoomContainer.classList.add('active');
        document.body.style.overflow = 'hidden';
        filterCarouselImages(crossIcon.dataset.colorSelected, crossIconIndex);
      });
    })
  }

function filterCarouselImages(color, slideIndex) {
  const galleryImages = document.querySelectorAll(".gallery-section__images-grid_item");
  const carouselContainer = document.querySelector('.slide-zoom-image_container');

  const filteredImages = [...galleryImages].filter((image) => {
    return image.classList.contains('images-selected');
  });
  
  carouselContainer.innerHTML = '';
  

  filteredImages.forEach((image) =>{
    let imageCarousel = generateHtmlZoomImg(image.children[1].getAttribute('src'), image.children[1].getAttribute('srcset'));
    carouselContainer.appendChild(imageCarousel);
  })
  const featured_image = generateHtmlZoomImg(document.querySelector('.featured-image-rebuild').dataset.modalImg);
  carouselContainer.appendChild(featured_image);

  $(document).ready(function() {
    $(carouselContainer).slick({
      dots: true,
      infinite: true,
      arrows: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
    $(carouselContainer).slick('slickGoTo', slideIndex);
  });
  openCloseModal('.close-zoom-image', '.slide-zoom-image', carouselContainer);
}

  const externalImage = document.querySelector('.cross-slick-modal');
  externalImage && externalImage.addEventListener('click', (event) => {
      const gridImagesContainer = document.querySelectorAll(".gallery-section__images-grid_item");
      const filteredImages = [...gridImagesContainer].filter((image) => {
        return image.classList.contains('images-selected');
      });

      const mainZoomContainer = document.querySelector('.slide-zoom-image');
      mainZoomContainer.classList.add('active');
      document.body.style.overflow = 'hidden';
      const colorSelected = document.querySelector('.color-selected').dataset.colorSelected.replace(/ /g, '-').toLowerCase();

      filterCarouselImages(colorSelected, filteredImages.length);
  });

  function openCloseModal(close, modal, carouselContainer) {
    let modalContainer = document.querySelector(modal);
    let closeIcon = document.querySelector(close);

    closeIcon.addEventListener('click', () => {
      document.body.style.overflowY = 'auto'; 
      if ($(carouselContainer).hasClass('slick-initialized')) {
        $(carouselContainer).slick('unslick');
      }
      modalContainer.classList.remove('active'); 
    });
  }

  // Function to generate HTML for the image
  function generateHtmlZoomImg(imageSrc, imageSrcSet) {
    const parentImage = document.createElement('div');
    const image = document.createElement('img');
    image.src = imageSrc;
    if (imageSrcSet != undefined) image.srcset = imageSrcSet && imageSrcSet;
    
    image.classList.add('carousel-image', 'lazyload-rebuild'); // Add a CSS class for styling, if needed
    parentImage.appendChild(image);
    parentImage.classList.add('parent-image-item'); // Add a CSS class for styling
    return parentImage;
  }
  //Funtions to creare the gallery on Rebuild 1
  function selectFirstImageAvailable(Images) {
    const galleryGridSlide = document.querySelectorAll('.gallery-section__images-item');

    //Put first image available as Main Image default
    const result = Images.filter(image => image.classList.contains('db-images'));   
    const firstImage = result[0];
   
    variantSeletedImg && [...variantSeletedImg.children].forEach(mainImage => {
          mainImage.classList.add('dn-i', 'fade-in');
          mainImage.classList.remove('mainimage-selected');
            if (firstImage.dataset.imageId === mainImage.dataset.imageId) {
              mainImage.classList.remove('dn-i', 'fade-in');
              mainImage.classList.add('mainimage-selected');
            }
            requestAnimationFrame((timestamp) => {
              removeFadeInClass(timestamp, mainImage);
            });
        });

    [...galleryGridSlide].forEach((img) => {
      if (img.dataset.image === productSelectEl.value) {
        img.classList.add('selected-active');
      }
    });
  }
  //Remove animations
  function removeFadeInClass(timestamp, element) {
    let startTime = null;
    const duration = 500; // Delay duration in milliseconds
    if (!startTime) {
      startTime = timestamp;
    }
  
    const elapsed = timestamp - startTime;
  
    if (elapsed < duration) {
      requestAnimationFrame((timestamp) => {
        removeFadeInClass(timestamp, element);
      });
    } else {
      element.classList.remove('fade-in');
    }
  }
  
  //Select the image selected
  function selectedImage() {
    const images = document.querySelectorAll('.gallery-section__images-item');
    [...images].forEach((image)  => {
      image.addEventListener("click", () => {
        images.forEach((img) => img.classList.remove('selected-active'));
        image.classList.add('selected-active');

        [...variantSeletedImg.children].forEach(mainImage => {
          mainImage.classList.add('dn-i');
          mainImage.classList.remove('mainimage-selected');
            if (image.dataset.imageId === mainImage.dataset.imageId) {
              mainImage.classList.remove('dn-i');
              mainImage.classList.add('mainimage-selected');
            }
            requestAnimationFrame((timestamp) => {
              removeFadeInClass(timestamp, mainImage);
            });
        });
      })
    })
  }

  function ZoomImagePopup(MainImage, containerImage, ppup, ImageToInsert, classes) {
    const mainImageSelected = MainImage && [...MainImage.children];
    mainImageSelected && mainImageSelected.forEach((mainImage) => {
      mainImage.addEventListener('click', () => {
        const containerPopup = document.querySelector(containerImage);
        const popup = document.querySelector(ppup);
        const image = document.querySelector(ImageToInsert);
        image.src = mainImage.dataset.originalSrc;  
        containerPopup.classList.add(classes);
        popup.classList.add(classes);
  
      })
    })
  }

  //Rebuild 1 draggable image from the container
  function draggableSlide(container){
    let isDown = false;
    let startX;
    let scrollLeft;
    const slider = document.querySelector(container);
    
    const end = () => {
      isDown = false;
      slider.classList.remove('active');
    }
    
    const start = (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;	
    }
    
    const move = (e) => {
      if(!isDown) return;
    
      e.preventDefault();
      const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
      const dist = (x - startX);
      slider.scrollLeft = scrollLeft - dist;
    }
    
    (() => {
      slider.addEventListener('mousedown', start);
      slider.addEventListener('touchstart', start);
    
      slider.addEventListener('mousemove', move);
      slider.addEventListener('touchmove', move);
    
      slider.addEventListener('mouseleave', end);
      slider.addEventListener('mouseup', end);
      slider.addEventListener('touchend', end);
    })();
  }
  function initProductVariants() {
    variantColorEls.forEach(variantColorEl => variantColorEl.addEventListener('click', handleClick));
    variantSizeEls.forEach(variantSizeEl => variantSizeEl.addEventListener('click', handleClick))
  }

  function accordions() {
    const accordion = document.querySelectorAll('.accordion-pdp');
    [...accordion].forEach((singleAccordion, index) => {
      singleAccordion.addEventListener('click', () => {
        singleAccordion.classList.toggle('active-pdp');
        const panel = singleAccordion.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
  
      // Set the first accordion as active
      if (index === 0) {
        singleAccordion.classList.add('active-pdp');
        const panel = singleAccordion.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  function addRemoveClass(optionName, selected, active) {
    let container = document.querySelectorAll(optionName);
    [...container].forEach(item =>{
      item.classList.remove(active);
    });
    selected.classList.add(active)
  }
  function UpdatePriceVariant(items, price) {
    let container = document.querySelectorAll(items);
    [...container].forEach(item =>{
      return item.textContent = `$${(price/100).toFixed(2)}`;
    });
  }
  function cutTheTextContent(textContent) {
    var decimal= /^[+-]?\d+(\.\d+)?$/;
    if (textContent.includes('/')) return textContent;
    if (decimal.test(textContent)) return textContent;
      return textContent.replace(/[^A-Z]/g, '')
  }  

  function removeAccordionEmpty() {
    [...document.querySelectorAll('.accordion-content')].forEach(item =>{
      if([...item.children].length == 0){
          item.classList.add('dn-i')
      }
    })
  }
  function galleryNosto() {
    let nosto2 = document.querySelector('#productpage-nosto-4'); 
    const nostoDesk = document.querySelector('.product-baseline-media');
    const nostoMob = document.querySelector('.nosto--mobile-wigets');

    if (window.innerWidth > 1024) return nosto2 && nostoDesk.append(nosto2);
    if (window.innerWidth < 1024) return nosto2 && nostoMob.append(nosto2);
  }
  //Resize the grid gallery on mobile Rebuild 3
const mainContainer = '.main-container-pdp-rebuild3';
const rebuildGridContainer = '.rebuild3-mobile-grid-container';
const gridContainer = '.gallery-resize-container-rebuild';
const draggableContainer = '.info-container-draggable';

function renderMobileDraggable (container){
  const mainContainer = document.querySelector(container);
  if (window.innerWidth < 768) {
    mainContainer.classList.add('rebuild3-mobile-grid-container');
  }else{
    mainContainer.classList.remove('rebuild3-mobile-grid-container');
  }
    resizeContainerMobile(rebuildGridContainer, true);
    resizeContainerMobile(gridContainer, false);
    resizeContainerMobile(draggableContainer, true);
    draggableMobile(draggableContainer);
  
}

function resizeContainerMobile(container, main) {
  const rebuildGrid = document.querySelector(container);  
  if (window.innerWidth < 768) {
      if (main) rebuildGrid.style.height = `${window.innerHeight}px`;
      else rebuildGrid.style.height = `${window.innerHeight - 400}px`;
    }
  }
function draggableMobile(container) {
  var containerElement = document.querySelector(container);
  const buttonDrag = document.querySelector('.button-draggable')
  const iconsFavShad = document.querySelector('.product-form__icons-ingrid');

  var isDragging = false;
  var initialY = 0;
  var offsetY = 0;
  if (window.innerWidth < 768) {
      function handleTouchMove(e) {
        if (!isDragging) return;
        e.preventDefault();
      
        var touchLocation = e.targetTouches[0];
        var newY = touchLocation.pageY - offsetY;
      
        const rect1 = document.querySelector(gridContainer)
        var deltaY = touchLocation.pageY - initialY;
        
        containerElement.classList.add('absolute-i');
        containerElement.style.top = newY + 'px';
        containerElement.style.transition = 'top 0.3s ease-out';

        if (parseInt(containerElement.style.top) < 4) {
          containerElement.style.top = '5px';
          iconsFavShad.style.position = 'absolute';
          return false;
        }
      
        if(parseInt(containerElement.style.top) > parseInt(rect1.style.height) && deltaY ) containerElement.style.top = parseInt(rect1.style.height) + 'px';
        iconsFavShad.style.position = 'fixed';
      }
    
      function handleTouchStart(e) {
        var touchLocation = e.targetTouches[0];
        isDragging = true;
        initialY = touchLocation.pageY;
        offsetY = touchLocation.pageY - containerElement.offsetTop;
        containerElement.style.overflow = 'auto';
      }
    
      function handleTouchEnd() {
        isDragging = false;
      }
      const removeOverflow = document.querySelector(mainContainer);
      removeOverflow.style.overflow = 'hidden';
      removeOverflow.addEventListener('touchmove', function(e) {
        if (e.target === removeOverflow) {
          e.preventDefault();
        }
      }, { passive: false });
    
      buttonDrag.addEventListener('touchstart', handleTouchStart);
      buttonDrag.addEventListener('touchmove', handleTouchMove);
      buttonDrag.addEventListener('touchend', handleTouchEnd);
  }else{
    containerElement.classList.remove('absolute-i');
    containerElement.style.overflow = 'unset';
  }

}
  if (!addToCartBtn) return;

  initProductVariants();

  setDefaultVariant();
  accordions();
  removeAccordionEmpty();
  if (templateName === 'rebuild-1') {
     galleryNosto();
     selectedImage();
  }
  ZoomImagePopup(variantSeletedImg, '.popup-container', '.popup', "#popup-image-zoom", 'active' );

if (templateName === 'rebuild-1') window.addEventListener("resize",galleryNosto);
// Call the resizeContainers function to set the initial container heights
if (templateName === 'rebuild-3') {
  crossIconModal();
  if (window.innerWidth < 768) renderMobileDraggable(mainContainer)
  window.addEventListener("resize", () => {
    if (window.innerWidth < 768) renderMobileDraggable(mainContainer)
  });
}  
  addToCartBtn.addEventListener('click', addToCartClickHandler);
    
})();

  //modal size 
  function openCloseModalG(modal, action) {
    const sizeChart = document.querySelector(modal);
          if(action) sizeChart.classList.add('size-chart-show')
          if(!action) sizeChart.classList.remove('size-chart-show')
  }